<template>
  <!-- 数据统计时间筛选组件 -->
  <div class="page">
    <section class="info-wrap">
      <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px">
        <el-form-item class="style" label="登记证书照片" prop="certCopy">
          <div class="img-wrap">
            <div class="img-list">
              <el-upload
                :class="ruleForm.certCopy && ruleForm.certCopy.length > 0 ? 'hide' : ''"
                list-type="picture-card"
                v-model="ruleForm.certCopy"
                :file-list="imgList"
                :action="$configUrl.uploadUrl"
                :on-remove="handleRemove"
                :on-success="
                  (response, file, fileList) => {
                    return handleAvatarSuccess(file, fileList);
                  }
                "
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </div>
        </el-form-item>
        <!-- <el-form-item class="style" label="登记证书类型" prop="certType">
          <el-input v-model="ruleForm.certType" placeholder="" clearable></el-input>
        </el-form-item> -->
        <el-form-item label="证书号" prop="certNumber">
          <el-input v-model="ruleForm.certNumber" placeholder="" clearable></el-input>
        </el-form-item>
        <el-form-item label="商户名称" prop="certificateInfoMerchantName">
          <el-input v-model="ruleForm.certificateInfoMerchantName" placeholder="" clearable></el-input>
        </el-form-item>
        <el-form-item label="注册地址" prop="companyAddress">
          <el-input v-model="ruleForm.companyAddress" placeholder="" clearable></el-input>
        </el-form-item>
        <el-form-item label="法人姓名" prop="certificateInfoLegalPerson">
          <el-input v-model="ruleForm.certificateInfoLegalPerson" placeholder="" clearable></el-input>
        </el-form-item>
        <el-form-item class="style" prop="cardType" label="证件有效期类型">
          <div>
            <el-radio-group v-model="ruleForm.cardType">
              <el-radio :label="0">固定有效期</el-radio>
              <el-radio :label="1">长期有效</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="有效期限开始日期" prop="periodBegin">
          <el-date-picker
            v-model="ruleForm.periodBegin"
            type="date"
            placeholder="选择日期"
            clearable
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item v-if="ruleForm.cardType === 0" label="有效期限结束日期" prop="periodEnd">
          <el-date-picker
            v-model="ruleForm.periodEnd"
            type="date"
            placeholder="选择日期"
            clearable
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item class="style" prop="type" label="类型">
          <div>
            <el-radio-group v-model="ruleForm.type" @change="changeType">
              <el-radio :label="0">已三证合一</el-radio>
              <el-radio :label="1">未三证合一</el-radio>
            </el-radio-group>
          </div>
          <span class="labels-tips"
            >若营业执照注册号为18位统一社会信用代码，请选择“已三证合一”，否则请选择“未三证合一”</span
          >
        </el-form-item>
      </el-form>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number || Boolean,
      default: false,
    },
    subjectData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      imgList: [],
      ruleForm: {
        certCopy: [],
        certType: '',
        certNumber: '',
        certificateInfoMerchantName: '',
        companyAddress: '',
        certificateInfoLegalPerson: '',
        periodBegin: '',
        periodEnd: '',
        cardType: 0,
        type: 0,
      },
      rules: {
        certCopy: [{ required: true, message: '请上传登记证书照片', trigger: ['blur', 'change'] }],
        cardType: [{ required: true, message: '', trigger: ['blur', 'change'] }],
        certType: [{ required: true, message: '请输入登记证书类型', trigger: ['blur', 'change'] }],
        certNumber: [{ required: true, message: '请输入证书号', trigger: ['blur', 'change'] }],
        certificateInfoMerchantName: [{ required: true, message: '请输入商户名称', trigger: ['blur', 'change'] }],
        companyAddress: [{ required: true, message: '请输入注册地址', trigger: ['blur', 'change'] }],
        certificateInfoLegalPerson: [{ required: true, message: '请输入法人姓名', trigger: ['blur', 'change'] }],
        periodBegin: [{ required: true, message: '请选择有效期限开始日期', trigger: ['blur', 'change'] }],
        periodEnd: [{ required: true, message: '请选择有效期限结束日期', trigger: ['blur', 'change'] }],
        type: [{ required: true, message: '', trigger: ['blur', 'change'] }],
      },
    };
  },

  watch: {
    count: {
      handler: function () {
        this.validity();
      },
    },
    subjectData: {
      handler: function (data) {
        console.log(data);
        this.ruleForm = data.subjectDataVO;
        let certCopyList = data.subjectDataVO.certCopy.split(',');
        this.imgList = certCopyList.map((item) => {
          const fileItem = {
            name: 'file',
            url: item,
            response: {
              data: item,
            },
          };
          return fileItem;
        });
      },
    },
  },

  methods: {
    handleAvatarSuccess(file, fileList) {
      console.log(file, fileList);
      this.ruleForm.certCopy = file.response.data.url;
      console.log(this.ruleForm.certCopy);
    },
    changeType() {
      this.$emit('changeType', this.ruleForm.type);
    },
    handleRemove() {
      this.ruleForm.certCopy = [];
    },
    validity() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit('confirm', { flag: true, ruleForm: this.ruleForm });
          console.log('验证通过');
        } else {
          this.$emit('confirm', { flag: false, ruleForm: this.ruleForm });
          console.log('验证失败');
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.info-wrap {
  box-sizing: border-box;
  padding-left: 31px;
}
.img-wrap {
  width: 700px;
  .img-list {
    height: 58px;
    overflow: hidden;
  }
  .hint {
    font-size: 12px;
    transform-origin: left;
    transform: scale(0.9);
    color: #fe4b48;
    margin-bottom: 5px;
  }
  /deep/ .el-upload--picture-card {
    width: 58px;
    height: 58px;
    line-height: 58px;
  }
  /deep/ .el-upload-list {
    /deep/.el-upload-list__item.is-success:first-child {
      &::before {
        position: absolute;
        left: 0;
        top: 0;
        content: '主图';
        color: #fff;
        width: 100%;
        height: 22px;
        font-size: 12px;
        text-align: center;
        line-height: 22px;
        background: rgba(0, 0, 0, 0.36);
      }
    }
  }
  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 58px;
    height: 58px;
    box-sizing: border-box;
  }
  /deep/ .el-upload--picture-card i {
    font-size: 14px;
  }
  /deep/ .el-upload-list__item-actions {
    width: 58px;
    height: 58px;
  }
  .hide {
    /deep/ .el-upload.el-upload--picture-card {
      display: none;
    }
  }
}
.labels-tips {
  font-size: 12px;
  font-weight: 500;
  color: #999999;
}
/deep/.el-input {
  width: 346px;
}
</style>
